import React, { PropTypes, Component } from 'react';
import moment from 'moment';
import Blazy from 'blazy';
import Classes from './gridhelper/generatePostClassesWithTerms';

class isotopeGrid extends Component {
  componentWillMount() {
    const post = this.props.post;
    this.termAsClasses = Classes.generatePostClassesWithTerms(post.terms);
  }
  componentDidMount() {
    this.showPopup(this.props);
    const bLazy = new Blazy();
  }
  componentDidUpdate() {
    this.showPopup(this.props);
  }
  showPopup(props) {
    const self = this;
    const post = props.post;
    jQuery(document).ready(() => {
      jQuery('.parent-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: false,
        },
      });
      jQuery('.parent-gallery-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
      if (post.post_format === 'standard') {
        jQuery('.parent-container').magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: false,
          },
        });
      }
      if (post.post_format === 'gallery') {
        jQuery('.parent-gallery-container').magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: true,
          },
        });
      }
      if (post.post_format === 'video') {
        jQuery('.open-popup').magnificPopup({
          type: 'iframe',
        });
      }
      if (post.post_format === 'audio') {
        jQuery('.open-audio').magnificPopup({
          type: 'iframe',
        });
      }
    });
  }
  render() {
    const { post, view } = this.props;
    const thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
    let termAsClasses = this.termAsClasses;
    termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
    const imgStyle = {
      backgroundImage: 'url(' + post.thumb_url + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      position: 'relative',
      width: '100%',
      height: '100%',
    };
    return (<div>
      { view === 'grid' ? <div>
        <div className="rq-image-grid">
          <div className="rq-grid-normal">
             <div className="">
                {post.thumb_url && post.post_format === 'standard' ?
                  <div className="rq-isotopegrid-image" >
                    <img src={post.thumb_url } alt={thumbAlt}/>
                    <div className="rq-image-overlay">
                      <a href={post.post_link}><i className="ion-link"></i></a>
                    </div>
                  </div>
                : ''}
                {post.meta.post_video !== undefined && post.post_format === 'video' ?
                  <a className="open-popup rq-post-standard" href={post.meta.post_video}>
                    <img src={API.IMG + 'placeholder-video.jpg'} />
                  </a> : ''}
                {post.meta.post_sound !== undefined && post.post_format === 'audio' ?
                  <a className="open-audio rq-post-standard" href={post.meta.post_sound}>
                    <img src={API.IMG + 'placeholder-audio.jpg'} />
                  </a> : ''}
            </div>
            <div className="post-content">
              <h2><a href={post.post_link}>{post.post_title}</a></h2>
              <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
              <span className="post-date">{ moment(post.post_date).format('ll') }</span>
            </div>
          </div>
        </div>
      </div>
      :
      <div className="flex-row">
        <div className="flex-md-12 flex-sm-12 flex-xs-12">
          <div className="rq-image-grid">
            <div className="rq-grid-normal with-left-image">
              <div className="flex-row">
                <div className="flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list" style={imgStyle}>
                     <div className="img-overlay parent-container"><a className="rq-gallery-popup-link" href={post.thumb_url}><i className="ion-android-add"></i><img src={post.thumb_url} alt={thumbAlt}/></a></div>
                </div>
                <div className="flex-md-7 flex-sm-12 flex-xs-12">
                  <div className="post-content">
                    <h2><a href={post.post_link}>{post.post_title}</a></h2>
                    <span className="post-date">{ moment(post.post_date).format('ll') }</span>
                    <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
                    <a href={post.post_link} className="btn btn-blog">{API.LANG.MORE}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </div>);
  }
}

ReactiveTemplates['isotopeGrid'] = isotopeGrid;

ReactiveLayouts.push({
  'key': 'isotopeGrid',
  'image_url': API.IMG + 'effect-goliath.jpg',
  'type': 'all',
  'format': 'standard',
  'gridName': 'MasonryGrid',
});


/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/layout/grid/masonryGrid.js
 **/